<template>
    <div>
        <div v-if="value && value.lembretes_pag && value.lembretes_pag.length" class="mt-3"> 
            <div class="alert alert-danger d-flex justify-content-between py-1" v-for="(lembrete, ilx) in value.lembretes_pag" :key="ilx">
                <div>
                    <i class="fas fa-thumbtack mr-3"></i>
                    <span style="white-space: pre-wrap;">{{ lembrete.st_lembrete }}</span>
                </div>
                <div>
                    <span class="small text-muted">
                        {{ lembrete.usuario.st_login }} | {{ $util.getFormatDate(lembrete.updated_at) }} {{ lembrete.updated_at.slice(11,16) }}
                    </span>

                    <a href="#" @click.prevent="editar(lembrete)" data-toggle="tooltip" data-placement="top" title="Editar Lembrete de Pagamento" class="ml-2" v-if="lembrete.id_usuario == $store.state.user.id_usuario">
                        <i class="fa-solid fa-pen"></i>
                    </a>
                </div>
            </div>
        </div>
        
        <div
            class="modal fade"
            id="lembretePagamentoModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Lembrete / Pagamento</h5>
                        <button type="button" class="close" @click="fechar ()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input 
                            type="textarea" 
                            v-model="edicao.st_lembrete" 
                            required
                            :validate="validate" />
                    </div>

                    <div class="modal-footer">
                        <az-audit-log-button model="lembretePagamento" :id="edicao.id_lembrete_pagamento"  />
                        <az-submit color="outline-danger" v-if="edicao.id_lembrete_pagamento" @click="removerLembrete ()">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" @click="fechar ()">Fechar</button>
                        <az-submit @click="atualizar ()">{{ edicao.id_lembrete_pagamento ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            st_lembrete: null, 
            st_lembrete_assistencia: null,
            tipo: 'G', 
            validate: false, 
            options_classes: [], 
            classes: [], 
            edicao: null,
        }
    },

    components: { 
        AzInput,
        AzSubmit,
        AzAuditLogButton, 
    },

    props: ['value'],

    computed: { 
        tem_lembrete_assistencia: function () { 
            if ( !this.value || !this.value.paciente_unidade )
                return false;

            return _.keys(this.value.paciente_unidade).find(item => item == 'st_lembrete_assistencia') ? true : false;
        },

        preenchido: function () { 
            if ( !this.value || !this.value.paciente_unidade )
                return false;

            return this.tipo == 'A' ? this.value.paciente_unidade.st_lembrete_assistencia : this.value.paciente_unidade.st_lembrete;
        }
    },

    methods: { 
        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.classes )
                this.classes = [];

            this.classes.push(newTag);
        },

        removerLembrete () { 

            this.$util.remover (this, { 
                service: 'lembrete_pagamentos',
                dados: { 
                    id_lembrete_pagamento: this.edicao.id_lembrete_pagamento,
                },
                modal: 'lembretePagamentoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        },

        atualizar () { 

            this.$util.atualizar (this, { 
                service: 'lembrete_pagamentos',
                func: 'store', 
                dados: this.edicao,
                modal: 'lembretePagamentoModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });

        },

        fechar () { 
            $('#lembretePagamentoModal').modal('hide');
        },

        incluir() { 
            this.validate = false;
            this.edicao = { 
                id_lembrete_pagamento: null, 
                id_atendimento: this.value.id_atendimento, 
                st_lembrete: null,
            };

            $('#lembretePagamentoModal').modal('show');
        },

        editar (lembrete) { 
            this.validate = false;
            this.edicao = _.cloneDeep(lembrete);

            $('#lembretePagamentoModal').modal('show');
        }
    },

    updated() {
      $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>
